export default [
  {
    path: '/pages/account-setting',
    name: 'pages-account-setting',
    component: () => import('@/views/pages/account-setting/AccountSetting.vue'),
  },
  {
    path: '/pages/synchronize',
    name: 'pages-synchronize',
    component: () => import('@/views/pages/news/SynchronizeNews.vue'),
  },
  {
    path: '/pages/calendar',
    name: 'pages-calendar',
    component: () => import('@/views/pages/calendar-events/Calendar.vue'),
  },
  // CRUD IMAGE LIBRARY
  {
    path: '/pages/image-library',
    name: 'pages-image-library',
    redirect: '/pages/image-library/list',
    component: () => import('@/views/admin/image-library/ImageLibrary.vue'),
    children: [
      {
        path: 'list',
        name: 'pages-image-library-list',
        component: () => import('@/views/admin/image-library/ImageLibraryList.vue'),
      },
    ]
  },
  // ASK ANALYST
  {
    path: '/pages/ask-analyst',
    name: 'pages-ask-analyst',
    props: route => ({ urlQuery: route.query }),
    component: () => import('@/views/pages/ask-analyst/AskAnalyst.vue'),
  },
  // ATTENDANCE
  {
    path: '/pages/attendance',
    name: 'pages-attendance',
    props: route => ({ urlQuery: route.query }),
    component: () => import('@/views/pages/attendance/Attendance.vue'),
  },
  // DASHBOARD
  {
    path: '/pages/dashboard',
    name: 'pages-dashboard',
    component: () => import('@/views/pages/dashboard/Dashboard.vue'),
  },
]